module.exports = __webpack_public_path__ + "static/media/bin-empty-state.d55ffd62.svg";